export default __webpack_public_path__ + "static/media/people13.9ecbfec1.jpeg";